<template>
    <v-card class="pa-4" outlined>
        <v-data-table
            :headers="headers"
            :items="linhas"
            :loading="carregando"
            :no-data-text="$t('ticketSuporteFluxo.historicoVazio')"
            item-key="id_historico"
            dense
            hide-default-footer
            disable-pagination
        >
            <template v-slot:[`item.origem`]="{ item }">
                <v-chip x-small outlined :color="item.origem === 'SISTEMA' ? 'primary' : 'grey'">
                    {{ $t(`ticketSuporteFluxo.origem.${item.origem}`) }}
                </v-chip>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import apiController from '@/utils/apiController';

/** Mudanças de status do ticket, com motivo e origem. Só superadmin e administradores (a API confere). */
export default {
    name: 'TicketHistoricoTab',
    props: {
        idTicket: { type: [Number, String], default: null }
    },
    data() {
        return { linhas: [], carregando: false };
    },
    computed: {
        headers() {
            const t = (k) => this.$t(`ticketSuporteFluxo.${k}`);
            return [
                { text: t('historicoData'), value: 'dt_alteracao_extenso', sortable: false },
                { text: t('historicoUsuario'), value: 'nome_usuario', sortable: false },
                { text: t('historicoDe'), value: 'status_anterior_extenso', sortable: false },
                { text: t('historicoPara'), value: 'status_novo_extenso', sortable: false },
                { text: t('historicoMotivo'), value: 'motivo', sortable: false },
                { text: t('historicoOrigem'), value: 'origem', sortable: false }
            ];
        }
    },
    watch: {
        idTicket: { immediate: true, handler: 'carregar' }
    },
    methods: {
        async carregar() {
            this.linhas = [];
            if (!this.idTicket) return;
            this.carregando = true;
            try {
                const res = await apiController.request(apiController.endpoints.getTickethistory, {
                    params: { id_ticket: this.idTicket },
                    silent: true
                });
                const dados = (res.data && res.data.dados) || [];
                this.linhas = dados.filter((h) => h.campo_alterado === 'id_status_dispatcher');
            } catch (e) {
                this.linhas = [];
            } finally {
                this.carregando = false;
            }
        }
    }
};
</script>
